import { render, staticRenderFns } from "./SiteIcon.vue?vue&type=template&id=0c9c2124&"
import script from "./SiteIcon.vue?vue&type=script&lang=js&"
export * from "./SiteIcon.vue?vue&type=script&lang=js&"
import style0 from "./SiteIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9c2124')) {
      api.createRecord('0c9c2124', component.options)
    } else {
      api.reload('0c9c2124', component.options)
    }
    module.hot.accept("./SiteIcon.vue?vue&type=template&id=0c9c2124&", function () {
      api.rerender('0c9c2124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/common/components/SiteIcon.vue"
export default component.exports